import React from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";
import { withRouter } from "react-router-dom";

import { PlanHeader, FeatureBox, MonthlyCost } from "Cobalt/Plan/Card";
import { Table, SnugTR, TD } from "Cobalt/TableV2";
import { Card, CardSection } from "Common/Card/";
import { Col, Row } from "Common/Grid";
import { Div } from "Common/HTML";
import { SizeSwitch } from "Common/Responsive";

import AddToCartButton from "./AddToCartButton";

import makeBem from "Utils/makeBem";

const bem = makeBem("AncillaryPlanCard");

export class AncillaryPlanCardDumb extends React.Component {
  isDental() {
    return this.props.plan.type === "dental" || this.props.plan.type === "individual_dental";
  }

  isVision() {
    return this.props.plan.type === "vision" || this.props.plan.type === "individual_vision";
  }

  formatTerm(term) {
    if (!term) {
      return "";
    }
    const idx = term.indexOf("<br>") > 0 ? term.indexOf("<br>") : term.indexOf("<br/>");
    return idx > 0 ? term.slice(0, idx) : term;
  }

  renderPlanDetailsDental() {
    const { plan, addPlanToCart } = this.props;

    return (
      <>
        <Row>
          <Col sm={6}>
            <Table>
              <SnugTR>
                <TD>Root Canals</TD>
                <TD>{plan.fine_print.Endodontics["Root Canal (single)"]}</TD>
              </SnugTR>
              <SnugTR>
                <TD>Gum Cleaning</TD>
                <TD>{plan.fine_print.Periodontics["Deep Cleaning (Scaling & Planing, per quadrant)"]}</TD>
              </SnugTR>
              <SnugTR>
                <TD>Braces</TD>
                <TD>{plan.fine_print.Orthodontics.Adult}</TD>
              </SnugTR>
            </Table>
          </Col>
          <Col sm={6}>
            <Table>
              <SnugTR>
                <TD>Crowns</TD>
                <TD>{plan.fine_print.Crowns["Porcelain and Steel"]}</TD>
              </SnugTR>
              <SnugTR>
                <TD>Extractions</TD>
                <TD>{plan.fine_print["Tooth Extraction"].Normal}</TD>
              </SnugTR>
              <SnugTR>
                <TD>Cavities</TD>
                <TD>{plan.fine_print.Cavities["Filling (1 surface)"]}</TD>
              </SnugTR>
            </Table>
          </Col>
        </Row>
        <Row pt={4}>
          <Col sm={4} smOffset={8}>
            <AddToCartButton addPlanToCart={addPlanToCart} planType={plan.type} plan={plan} />
          </Col>
        </Row>
      </>
    );
  }

  renderPlanDetailsVision() {
    const { plan, addPlanToCart } = this.props;
    const examFrequency = plan.fine_print.Basic["Benefit Frequency Exams"].inNetwork;
    const lensesFrequency = plan.fine_print["Eyeglass Lenses"]["Benefit Frequency Lenses"].inNetwork;

    const framesFrequency = plan.fine_print.Frames["Benefit Frequency Frames"].inNetwork;
    const contactsFrequency = plan.fine_print["Contact Lenses"]["Benefit Frequency Lenses"].inNetwork;

    return (
      <Row className="flex items-end">
        <Col sm={8}>
          <Table>
            <SnugTR>
              <TD>Eye Exam</TD>
              <TD>
                {this.formatTerm(plan.eye_exam)} ({examFrequency})
              </TD>
            </SnugTR>
            <SnugTR>
              <TD>Contact Lenses</TD>
              <TD>
                {this.formatTerm(plan.contacts)} ({contactsFrequency})
              </TD>
            </SnugTR>
            <SnugTR>
              <TD>Lenses</TD>
              <TD>
                {this.formatTerm(plan.lenses)} ({lensesFrequency})
              </TD>
            </SnugTR>
            <SnugTR>
              <TD>Frames</TD>
              <TD>
                {this.formatTerm(plan.frames)} ({framesFrequency})
              </TD>
            </SnugTR>
          </Table>
        </Col>
        <Col sm={4}>
          <Div>
            <AddToCartButton addPlanToCart={addPlanToCart} planType={plan.type} plan={plan} />
          </Div>
        </Col>
      </Row>
    );
  }

  renderCardHeader() {
    const { plan } = this.props;
    return (
      <CardSection className={classnames(bem("Summary"), this.isVision() ? bem("Summary", "Vision") : "")} py={isIntuit() ? 3 : 4} onClick={this.toggle}>
        <PlanHeader plan={plan} />
        {this.isDental() && (
          <>
            <FeatureBox plan={plan} title="Max Benefit" field="annual_maximum" format="currency" />
            <FeatureBox plan={plan} title="Deductible" field="deductible" format="currency" />
            <FeatureBox plan={plan} title="Preventative" field="preventive_care" format="capitalize" />
            <FeatureBox plan={plan} title="Network Type" field="plan_type" format="acronym" />
          </>
        )}
        {this.isVision() && (
          <>
            <FeatureBox plan={plan} title="Exam" field="eye_exam" format="html" />
            <FeatureBox plan={plan} title="Lenses" field="lenses" format="html" />
            <FeatureBox plan={plan} title="Contacts" field="contacts" format="html" />
          </>
        )}
        <Div className={bem("PlanHeaderActions")}>
          <MonthlyCost cost={plan.average_monthly_premium} loading={false} hasFootnote={false} />
        </Div>
      </CardSection>
    );
  }

  renderCardDesktop() {
    const { plan } = this.props;
    return (
      <>
        {this.renderCardHeader()}
        <CardSection pt={0} style={{ borderTop: "1px solid #e0e0e0" }}>
          {this.isDental() ? this.renderPlanDetailsDental() : this.renderPlanDetailsVision()}
        </CardSection>
      </>
    );
  }

  renderCardMobile() {
    const { plan, addPlanToCart } = this.props;
    return (
      <>
        <CardSection className={bem("Summary")}>
          <PlanHeader plan={plan} />
          <Div className={bem("PlanHeaderActions")}>
            <MonthlyCost cost={plan.average_monthly_premium} loading={false} hasFootnote={false} />
          </Div>
        </CardSection>
        <CardSection className={bem("Summary", "Features")}>
          {this.isDental() && (
            <>
              <FeatureBox plan={plan} title="Max Benefit" field="annual_maximum" format="currency" />
              <FeatureBox plan={plan} title="Deductible" field="deductible" format="currency" />
              <FeatureBox plan={plan} title="Preventative" field="preventive_care" format="capitalize" />
            </>
          )}
          {this.isVision() && (
            <>
              <FeatureBox plan={plan} title="Exam" field="eye_exam" format="html" />
              <FeatureBox plan={plan} title="Lenses" field="lenses" format="html" />
              <FeatureBox plan={plan} title="Contacts" field="contacts" format="html" />
            </>
          )}
        </CardSection>
        <AddToCartButton addPlanToCart={addPlanToCart} planType={plan.type} plan={plan} />
      </>
    );
  }

  render() {
    const { plan, addPlanToCart } = this.props;
    return (
      <Card
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        mb={2}
        mt={2}
        p={0}
        className={classnames(bem(), isIntuit() ? bem(null, "intuit") : null, bem(null, "open"))}
      >
        <SizeSwitch md={this.renderCardDesktop()} xs={this.renderCardMobile()} />
      </Card>
    );
  }
}

export default withRouter(AncillaryPlanCardDumb);
